<!--Field type three start -->
<ng-container *ngIf="field.appearance === FieldAppearance.TYPE_3">
    <div
        class="form-row {{ field.extraClass }}"
        [ngClass]="'checkbox-container'"
    >
        <span class="form-label">
            {{ field.label }}
            <span *ngIf="field.required"> * </span>

            <mat-icon
                *ngIf="field.prefixIcon"
                matPrefix
                [matTooltip]="field.prefixIcon.hoverText"
                class="clickable"
                (click)="
                    field.prefixIcon.function
                        ? field.prefixIcon.function(field, formGroup)
                        : null
                "
            >
                {{ field.prefixIcon.iconData.class }}
            </mat-icon>
        </span>

        <mat-checkbox
            [name]="field.name"
            [required]="field.required !== undefined ? field.required : true"
            [class.disabled]="
                formGeneratorInput.state === FormState.IDLE || field.disabled
            "
            (change)="
                updateHiddenFields();
                field.onChange
                    ? field.onChange($event, formGroup, field.name)
                    : null
            "
            [formControl]="control"
            [errorStateMatcher]="matcher"
        >
        </mat-checkbox>
        <!-- Handling errors -->
        <ng-container *ngIf="!field.groupByKey">
            <ng-template *ngTemplateOutlet="error"></ng-template>
        </ng-container>
        <ng-container *ngIf="field.groupByKey">
            <ng-template *ngTemplateOutlet="groupError"></ng-template>
        </ng-container>
    </div>
</ng-container>
<!--Field type three end -->

<!--Field type four start -->
<ng-container *ngIf="field.appearance === FieldAppearance.TYPE_4">
    <div class="form-row {{ field.extraClass }}">
        <mat-checkbox
            [name]="field.name"
            [required]="field.required !== undefined ? field.required : true"
            [class.disabled]="
                formGeneratorInput.state === FormState.IDLE || field.disabled
            "
            (change)="
                updateHiddenFields();
                field.onChange
                    ? field.onChange($event, formGroup, field.name)
                    : null
            "
            [formControl]="control"
            [errorStateMatcher]="matcher"
        >
            <span>{{ field.label }} </span>
        </mat-checkbox>
        <!-- Handling errors -->
        <ng-container *ngIf="!field.groupByKey">
            <ng-template *ngTemplateOutlet="error"></ng-template>
        </ng-container>
        <ng-container *ngIf="field.groupByKey">
            <ng-template *ngTemplateOutlet="groupError"></ng-template>
        </ng-container>
    </div>
</ng-container>
<!--Field type four end -->
<!--Field type four start -->
<ng-container *ngIf="field.appearance === FieldAppearance.TYPE_5">
    <div class="form-row {{ field.extraClass }}">
        <mat-checkbox
            [name]="field.name"
            [required]="field.required !== undefined ? field.required : true"
            [class.disabled]="
                formGeneratorInput.state === FormState.IDLE || field.disabled
            "
            (change)="
                updateHiddenFields();
                field.onChange
                    ? field.onChange($event, formGroup, field.name)
                    : null
            "
            [formControl]="control"
            [errorStateMatcher]="matcher"
        >
        </mat-checkbox>
    </div>
</ng-container>
<!--Field type four end -->

<!--Field type Indreka Checkbox start -->
<ng-container *ngIf="field.appearance === FieldAppearance.INDREKA_CHECKBOX">
    <div class="form-row {{ field.extraClass }}">
        <indreka-checkbox
            [name]="field.name"
            [required]="field.required !== undefined ? field.required : true"
            [disabled]="formGeneratorInput.state === FormState.IDLE || field.disabled"
            (checkboxEvent)="
                updateHiddenFields();
                field.onChange
                    ? field.onChange($event, formGroup, field.name)
                    : null   "
            [error]="matcher"
        >
        </indreka-checkbox>
    </div>
</ng-container>
<!--Field type Indreka Checkbox end -->

<!-- Error Templates -->
<ng-template #groupError>
    <ng-container
        *ngIf="
            formGroup.get(field.groupByKey).get(field.name).touched &&
            formGroup.get(field.groupByKey).get(field.name).errors
        "
    >
        <mat-error>
            {{
                field.validations
                    | formErrorValidation
                        : formGroup.get(field.groupByKey).get(field.name).errors
            }}
        </mat-error>
    </ng-container>
</ng-template>
<ng-template #error>
    <ng-container
        *ngIf="
            formGroup.get(field.name).touched &&
            formGroup.get(field.name).errors
        "
    >
        <mat-error>
            {{
                field.validations
                    | formErrorValidation: formGroup.get(field.name).errors
            }}
        </mat-error>
    </ng-container>
</ng-template>
